const environment = "production"; //dev, staging, production

export default ({
    'url': environment === "dev" ? "http://localhost:3000" : environment === "staging" ? "https://www.playftstaging.web.app" : "https://www.playfuturetraders.com"
});